package pwgs.ui.scenes.playererrorsscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class APlayerErrorsControllerFe(props: pwgs.ui.scenes.playererrorsscene.PlayerErrorsSceneProps, scene: MPlayerErrorsScene)
 : AController<pwgs.ui.scenes.playererrorsscene.PlayerErrorsSceneProps, pwgs.ui.scenes.playererrorsscene.PlayerErrorsSceneModel, PlayerErrorsSceneState>(props, scene) {

    val backend = PlayerErrorsControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class PlayerErrorsControllerBeProxy(private val controller: APlayerErrorsControllerFe) {

    suspend fun load(): pwgs.ui.scenes.playererrorsscene.PlayerErrorsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.playererrorsscene.PlayerErrorsControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.playererrorsscene.PlayerErrorsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.playererrorsscene.PlayerErrorsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.playererrorsscene.PlayerErrorsSceneModel.serializer())
        }
    }

}
